import React from 'react'
import styled from 'styled-components'

const Text = styled.h1`
position: fixed;
top: ${props => props.top};

left: 30%;
transform: translateX(-50%);

color:${props => `rgba(${props.theme.textRgba},0.22)`};
font-size: calc(5rem + 5vw);
z-index:0;
white-space: nowrap;

/* Tablet Range (769px – 1024px) */
@media (max-width: 1024px) and (min-width: 769px){
  font-size: 7rem;   /* increase size */
}

/* Mobile Fix */
@media (max-width: 768px){
  font-size: calc(4.5rem + 1vw);
  left: 50%;
}
`

const BigTitlte = (props) => {
    return (
        <Text top={props.top}>
            {props.text}
        </Text>
    )
}

export default BigTitlte
